import { render, staticRenderFns } from "./screenReactions.vue?vue&type=template&id=61f4d000&scoped=true&"
import script from "./screenReactions.vue?vue&type=script&lang=js&"
export * from "./screenReactions.vue?vue&type=script&lang=js&"
import style0 from "./screenReactions.vue?vue&type=style&index=0&id=61f4d000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4d000",
  null
  
)

export default component.exports